import { BarChart } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { chartsGridClasses } from '@mui/x-charts/ChartsGrid';
import { useEffect, useState } from 'react';


function WaterHistoryChart({ details }) {
    const [smallSize, setSmallSize] = useState(false)

    useEffect(() => {
        // Function to update the window width
        const handleResize = () => {
            if (window.innerWidth < 700) {
                setSmallSize(true)
            } else {
                setSmallSize(false)
            }
        };

        handleResize()

        // Attach the resize event listener
        window.addEventListener('resize', handleResize);

        // Clean up the event listener on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div>
            <BarChart
                sx={{
                    [`.${axisClasses.root}`]: {
                        [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                            stroke: 'transparent',
                            strokeWidth: 3,
                        },
                    },
                    [`.${chartsGridClasses.line}`]: {
                        strokeDasharray: '5 3',
                        strokeWidth: 1
                    },
                }}
                grid={{ horizontal: true }}
                dataset={details.map(day => day.data)}
                xAxis={[{
                    scaleType: 'band',
                    tickFontSize: 14,
                    tickLabelStyle: {
                        fontFamily: 'Inter',
                        fontWeight: '600',
                        fill: '#96948F',

                    },
                    tickSize: 20,
                    categoryGapRatio: smallSize ? 0.24 : 0.45,
                    barGapRatio: smallSize ? 0.3 : .4,
                    data: details.map(day => day.label)
                }]}
                yAxis={[{
                    tickFontSize: smallSize ? 12 : 14,
                    tickSize: 20,
                    tickLabelStyle: {
                        fontFamily: 'Inter',
                        fontWeight: '600',
                        fill: '#96948F',

                    },
                    disableTicks: smallSize,
                }]}
                slotProps={{ legend: { hidden: true } }}
                series={[
                    { dataKey: 'amount', label: 'Amount', color: `url(#amountGradient)` },
                ]}
                margin={{ left: smallSize ? 55 : 90, right: smallSize ? 50 : 75 }}
                borderRadius={6}
                height={400}
            >
                <defs>
                    <linearGradient id="amountGradient" x1="0" x2="0" y1="0" y2="1">
                        <stop offset="0%" stopColor="#8EC3E9" />
                        <stop offset="100%" stopColor="#6DAAD6" />
                    </linearGradient>
                </defs>
            </BarChart>
        </div>
    );
}


export default WaterHistoryChart;